module.exports = __webpack_public_path__ + "static/media/woman-working-on-laptop-sitting-at-desks-with-cup-work.cc0e7bac.png";